import React, { useContext } from 'react';
import {
  ProductDetail,
} from 'anf-core-react';
import ProductPageContext from '../../contexts/ProductPageContext';

export default function MerchPromoMessage() {
  const ProductPageState = useContext(ProductPageContext);

  const {
    collectionData,
  } = ProductPageState;

  if (!collectionData || !collectionData.activeProduct) {
    return null;
  }

  const {
    merchPromoMessage,
  } = collectionData.activeProduct;

  return (
    merchPromoMessage?.message && (
    <ProductDetail>
      <div className="promo-badge" data-testid="promo-message">
        <span className={`promo-info--${merchPromoMessage.type === 'tiered' ? 'bogo' : merchPromoMessage.type}`}>
          {merchPromoMessage.message}
        </span>
      </div>
    </ProductDetail>
    )
  );
}
